module.exports = __webpack_public_path__ + "static/los-york-bb677a8396e1ff9e8b34da458f43f254.png";